(async () => {
  const el = document.getElementById('doctor-section-practice')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/[town_translit]/vrach/[doctor_translit]/index.vue'),
    },
  ]

  await clientRender({ components })
})()
